module.exports = __webpack_public_path__ + "img/CT.Bridges.Parapets_.Steel_Parapet_(H4a).Steel.4dbdf804.png";